/**
 * Transforms a data map by prefixing each key with "My" and converting it to lowercase. (#10998)
 * @param dataMap - The original data map with string keys and values.
 * @returns A new data map with transformed keys.
 */
export default function transformDataMap(dataMap: Record<string, string>) {
  return Object.keys(dataMap).reduce<Record<string, string>>((acc, curKey) => {
    acc[`My${curKey.toLowerCase()}`] = dataMap[curKey]

    return acc
  }, {})
}
